import {RouteObject} from "react-router-dom";
import {REWARD_DETAILS} from "../../constants/urls";

export default [
    {
        index: true,
        lazy: () => import("modules/reward/routes/Reward"),
    },
    {
        path: REWARD_DETAILS,
        lazy: () => import("modules/reward/routes/RewardDetails"),
    },
] as RouteObject[];
